export const GET_THEME = "GET_THEME";
export const CREATE_NEW_THEME = "CREATE_NEW_THEME";
export const EDIT_THEME = "EDIT_THEME";
export const DELETE_THEME = "DELETE_THEME";

export const OPEN_THEME_DIALOG = "OPEN_THEME_DIALOG";
export const CLOSE_THEME_DIALOG = "CLOSE_THEME_DIALOG";
